var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.66669V4.00002H13.3333L10 9.00002V14.6667H6V9.00002L2.66667 4.00002H2V2.66669H14ZM4.26913 4.00002L7.33333 8.59629V13.3334H8.66667V8.59629L11.7309 4.00002H4.26913Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-line.a3e44e12.svg";
export { ForwardRef as ReactComponent };